export default "__VITE_ASSET__4IemmJPN__"